import React from "react";
import Loader from "../Loader/Loader";
import authLoadingStyles from "./authLoadingStyles";
import { makeStyles, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => authLoadingStyles(theme));

const AuthLoading = () => {
  const classes = useStyles();

  return (
    <div className={classes.content}>
      <Loader/>
      <Typography
        component="p"
        color="inherit"
        className={classes.title}
      >
        Verificando o usuário, aguarde...
      </Typography>
    </div>
  )
}

export default AuthLoading
